module.exports = __webpack_public_path__ + "static/bkash-home-dbbabe595456c3bd8847885f9868b37d.png";